import React from 'react';
import './ActivityLog.scss';
import {navigate} from "@reach/router";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import moment from "moment";
import Button from "@material-ui/core/Button";


function ActivityLogItem(props) {

  let icon = '';
  let type = 'NOTIFICATION';
  let title = '';

  switch(props.activity.type){
    case "VAULT_CREATED":
      icon = 'folder-plus';
      title = 'New vault created';
      break;
    case "VAULT_FILES_EDITED":
      icon = 'file-upload';
      title = 'New files uploaded to vault';
      break;
    case "ACCESS_REQUESTED":
      icon = 'key';
      type = 'ALERT';
      title = 'Access requested to vault';
      break;
    case "ACCESS_REQUEST_APPROVED":
      icon = 'check';
      type = 'ALERT';
      title = 'Keyholders granted access';
      break;
    case "ACCESS_REQUEST_DENIED":
      icon = 'lock';
      type = 'ALERT';
      title = 'Access request denied';
      break;
    case "ACCESS_REQUEST_CANCELLED":
      icon = 'lock';
      title = 'Access request cancelled';
      break;
    case "VAULT_LOCKED":
      icon = 'lock';
      title = 'Vault has been locked';
      break;
    case "VAULT_ARCHIVED":
      icon = 'box';
      title = 'Vault has been archived.';
      break;
    case "VAULT_UNARCHIVED":
      icon = 'box-open';
      title = 'Vault has been un-archived.';
      break;
  }

  const lastUpdated = moment.duration(moment().diff(moment(props.activity.created)));

  return <Button key={props.activity.created} className="activity-container w-full" onClick={() => navigate(`/vaults/${props.activity.vaultId}`)}>
    <div className="flex activity-inner-container">
      <div className="activity-icon-container">
        <FontAwesomeIcon icon={icon} size={'lg'} className={`${type === 'ALERT' ? 'text-alert': 'text-grey'}`}/>
      </div>
      <div className="flex-1">
        <p className={`text-sm ${type === 'ALERT' ? 'text-alert': 'text-grey'}`}>{type}</p>
        <div>
          <p className="font-bold">{title}</p>
          <div className="vault-title-text mt-2 text-sm">
            {props.activity.vaultName}
          </div>
        </div>
        <p className="text-xs text-grey">{ lastUpdated.humanize() } ago</p>
      </div>
    </div>
  </Button>
};

export default ActivityLogItem;
